export default __webpack_public_path__ + "static/media/Believer's Straps of the Three Clarities.048378b0.jpg";